import React, {useContext} from 'react';
import { useState } from 'react';
import styled from "styled-components";
import { T } from '../../utils/I18n/I18n'

import { Link } from 'react-router-dom';
import DesktopResponsive from "../NewsletterMobileBanner/DesktopResponsive";

import './NewsletterSlider.scss';
import {useTranslation} from "react-i18next";

const Animation = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'animate', // Nie przekazuj 'animate' do DOM
})`
    transform: ${({ animate }) => (animate ? 'translateX(0%)' : 'translateX(-400px)')};
    transition: transform 0.5s;
    opacity: 1;
`;

const NewsletterSlider = () => {
    const { t, i18n } = useTranslation();
    const [isOpen, setOpen] = useState(false);
    const toggleModal = () => setOpen(prevState => !prevState);
    // const { t } = useTranslation();

    function Content(props) {
        return <Animation animate={props.isOpen}>
            <div className={`newsletterSlideoutContent ${
                !isOpen ? "newsletterSlideoutContent-closed" : "newsletterSlideoutContent-opened"
            }`}>
                    <div className="slideoutImage"></div>
                    <p className="newsletterSignUp">
                        <T id="newsletterSlider.newsletterSignUp" />
                        <span className="boldText">
                            <T id="newsletterSlider.boldText" />
                        </span>
                    </p>
                    <p className="newsletterSignUpSmall">
                        <T id="newsletterSlider.newsletterSignUpSmall" />
                    </p>
                    <p className="newsletterSignUpButton">
                        
                        <Link to={`/${t('newsletterSlider.newsletterLink')}/`}>
                            <button className="action" onClick={toggleModal}>
                                <T id="newsletterSlider.signUpButton" />
                            </button>
                        </Link>
                    </p>
            </div>
        </Animation>;
    }

    if (DesktopResponsive().isDesktop) {
        return (
            <div className="newsletterSlideout">
                <Content isOpen={isOpen} />

                <button type="button" onClick={toggleModal} className={`action newsletterSlideoutButton ${
                    !isOpen ? "newsletterSlideoutButton-closed" : "newsletterSlideoutButton-opened"
                }`}>
                <span className="buttonText">
                    <T id="newsletterSlider.buttonText" />
                </span>
                </button>
            </div>
        );
    }
        return null;


};

export default NewsletterSlider;
